import { UserService } from '@fnv-core/authentication';
import { STORE_USER, CLEAR_USER } from '../constants/Constants';
import { User } from '../models/User';

export const userReducer = (state : User = {
  email : "",
  name : "",
  lidnummer: "",
  accessToken: "",
  isLoggedIn: false,
  membershipCardActivatedDate: "",
  birthDate : "",
  userId: "",
  roles: []
}, action) => {
    switch (action.type) {
      case STORE_USER:
      {
        UserService.setLidnummer(action.payload.lidnummer);
        UserService.setUserId(action.payload.userId);
        UserService.setBondsId(action.payload.lidnummer && action.payload.lidnummer.length > 2 ? action.payload.lidnummer.substring(0, 2) : "");
        UserService.setUserRoles(action.payload.roles);

        return {
          email: action.payload.email,
          name: action.payload.name,
          lidnummer : action.payload.lidnummer,
          accessToken : action.payload.accessToken,
          birthDate : action.payload.birthDate,
          membershipCardActivatedDate: action.payload.membershipCardActivatedDate,
          userId: action.payload.userId,
          roles: action.payload.roles,
          isLoggedIn : true
        };
      }        
      case CLEAR_USER:
        UserService.setLidnummer("");
        UserService.setUserId("");
        UserService.setBondsId("");
        UserService.setUserRoles([]);
        
        return {
          email : "",
          name : "",
          lidnummer: "",
          accessToken: "",
          membershipCardActivatedDate: "",
          birthDate : "",
          userId : "",
          roles: [],
          isLoggedIn: false
        };      
      default:
        return state;
    }
};